import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Container, Paper } from '@mui/material';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { makeRequest } from '../../../assets/functions_helper';
import ReservationForm from './reservation_form';

// Manejo seguro para el Site Key en desarrollo o cuando no está configurado
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'; // Clave de test pública por defecto

function PublicReservation() {
  const { restaurant_public_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [operatingHours, setOperatingHours] = useState(null);
  const [errorInfo, setErrorInfo] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [reservationId, setReservationId] = useState('');

  useEffect(() => {
    // Carga de horarios de operación
    makeRequest(
      'GET',
      `reservations/operating-hours?restaurant_public_id=${restaurant_public_id}`,
      null,
      'application/json',
      null, // No auth token since public
      null,
      null,
      true // disable common error handling redirect
    )
      .then((data) => {
        setOperatingHours(data || {});
      })
      .catch((error) => {
        console.error('Error fetching operating hours:', error);
        setErrorInfo('El restaurante no está recibiendo reservaciones en este momento.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [restaurant_public_id]);

  const handleSuccess = (refId) => {
    setReservationId(refId);
    setIsSuccess(true);
  };

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: '#f8fafc' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (errorInfo) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: '#f8fafc', p: 3 }}>
        <Typography variant="h6" color="error" textAlign="center">{errorInfo}</Typography>
      </Box>
    );
  }

  if (isSuccess) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Paper elevation={0} sx={{ p: 6, borderRadius: '24px', textAlign: 'center', border: '1px solid #e2e8f0', bgcolor: '#ffffff' }}>
          <Box sx={{ fontSize: '4rem', mb: 2 }}>🎉</Box>
          <Typography variant="h4" sx={{ fontWeight: 800, color: '#1e293b', mb: 2, fontFamily: 'Como, sans-serif' }}>
            ¡Solicitud Enviada!
          </Typography>
          <Typography variant="body1" sx={{ color: '#64748b', mb: 4 }}>
            El restaurante revisará tu solicitud y te confirmará en breve. Tu código de referencia es:
          </Typography>
          <Box sx={{ bgcolor: '#f1f5f9', p: 3, borderRadius: '16px', border: '2px dashed #cbd5e1', overflow: 'hidden' }}>
            <Typography 
              variant="h3" 
              sx={{ 
                fontWeight: 900, 
                color: '#0f172a', 
                letterSpacing: { xs: 1, sm: 2 }, 
                fontFamily: 'monospace',
                fontSize: { xs: '1.4rem', sm: '2rem', md: '2.5rem' },
                wordBreak: 'break-all',
                overflowWrap: 'break-word'
              }}
            >
              {reservationId}
            </Typography>
          </Box>
        </Paper>
      </Container>
    );
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', py: { xs: 4, md: 8 } }}>
        <Container maxWidth="md">
          <Box sx={{ mb: 6, textAlign: 'center' }}>
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', fontFamily: 'Como, sans-serif' }}>
              Haz tu Reserva
            </Typography>
            <Typography variant="subtitle1" sx={{ color: '#64748b', mt: 1 }}>
              Selecciona los detalles para tu visita
            </Typography>
          </Box>
          <ReservationForm
            restaurantId={restaurant_public_id}
            operatingHours={operatingHours}
            onSuccess={handleSuccess}
          />
        </Container>
      </Box>
    </GoogleReCaptchaProvider>
  );
}

export default PublicReservation;
